'use client'

import dynamic from 'next/dynamic'
import { useEffect } from 'react'

import { ButtonBooking } from '@/components/home/btn-book'

import { useDestination } from '../context/DestinationContext'
import { BaseColorSetter } from './BaseColorSetter'

const BookingFormComponent = dynamic(
  () => import('@/components/forms/booking').then((mod) => mod.BookingFormComponent),
  { ssr: false, loading: () => <div className='booking-form-placeholder'></div> }
)

interface DestinationClientWrapperProps {
  children: React.ReactNode
}

export default function DestinationClientWrapper({ children }: DestinationClientWrapperProps) {
  const { data, isMobile } = useDestination()

  useEffect(() => {
    if (data?.branches?.length && typeof performance !== 'undefined') {
      performance.mark('cities-rendered')
    }
  }, [data?.branches])

  return (
    <div className='ui--location'>
      <BaseColorSetter />
      <section className='ui--location-section'>
        <>
          {isMobile ? (
            <div className='ui--location-booking-btn'>
              <ButtonBooking />
            </div>
          ) : (
            <BookingFormComponent />
          )}
        </>
        {children}
      </section>
    </div>
  )
}
